import { parseDate } from "helpers/date";
import { parsePrice, centsToDollars } from "helpers/price";
import { Label } from "layout/typography/Label";
import { InputText } from "primereact/inputtext";
import { useMemo } from "react";
import { IPayment } from "types/Payment";

export function PaymentDetailsSection({ payments }: { payments: IPayment[] }) {
  const paidPayment: IPayment | undefined = useMemo(() => {
    const firstPaidPayment = payments?.find(
      (aPayment) => aPayment.status === "Paid"
    );

    if (!firstPaidPayment || !firstPaidPayment.splitTotalPaymentId) {
      return firstPaidPayment;
    }

    // If this is a split payment, find all payments with the same splitTotalPaymentId
    const splitPayments = payments?.filter(
      (payment) =>
        payment.splitTotalPaymentId === firstPaidPayment.splitTotalPaymentId &&
        payment.status === "Paid"
    );

    // Calculate total amount across all split payments
    const totalAmountInCents = splitPayments?.reduce(
      (total, payment) => total + (payment.amountInCents || 0),
      0
    );

    // Return the first payment but with the total amount from all split payments
    return {
      ...firstPaidPayment,
      amountInCents: totalAmountInCents,
    };
  }, [payments]);

  const depositDate = useMemo(() => {
    return paidPayment?.stripePayout?.payoutArrivalDate
      ? parseDate(paidPayment.stripePayout.payoutArrivalDate, false, true)
      : "-";
  }, [paidPayment]);
  return (
    <div className="formgrid grid w-100">
      <div className="field flex flex-column col-12 md:col-4">
        <Label htmlFor="paymentDate">Payment Date</Label>

        <InputText
          disabled
          id="paymentDate"
          aria-labelledby="paymentDate"
          value={
            paidPayment?.createdAt
              ? parseDate(paidPayment.createdAt, false, true)
              : "-"
          }
        />
      </div>

      <div className="field flex flex-column col-12 md:col-4">
        <Label htmlFor="paymentAmount">Payment Amount</Label>

        <InputText
          disabled
          id="paymentAmount"
          aria-labelledby="paymentAmount"
          value={
            paidPayment?.amountInCents
              ? parsePrice(centsToDollars(paidPayment.amountInCents))
              : "-"
          }
        />
      </div>

      <div className="field flex flex-column col-12 md:col-4">
        <Label htmlFor="depositDate">Deposit Date</Label>

        <InputText
          disabled
          id="depositDate"
          aria-labelledby="depositDate"
          value={depositDate}
        />
      </div>

      <div className="field flex flex-column col-12 md:col-4">
        <Label htmlFor="paymentMethod">Payment Method</Label>

        <InputText
          disabled
          id="paymentMethod"
          value={paidPayment?.type || "-"}
          aria-labelledby="paymentMethod"
        />
      </div>

      <div className="field flex flex-column col-12 md:col-4">
        <Label htmlFor="paymentStatus">Status</Label>

        <InputText
          disabled
          id="paymentStatus"
          value={paidPayment?.status || "-"}
          aria-labelledby="paymentStatus"
        />
      </div>
    </div>
  );
}
